import React, { useEffect, useState } from 'react';

import Button from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';

import jira from 'src/lib/api/jira';
import { changeMinHeight } from 'src/lib/resize';

import WebhooksTasksTable from 'src/views/Admin/Modals/components/WebhooksTasksTable';
import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalButtons from 'src/views/components/ModalButtons';
import ModalContainer from 'src/views/components/ModalContainer';

import { useDiffWebhooks } from './useDiffWebhooks';

const ErorrsMessage = () => (
  <SectionMessage appearance="warning" title="Failed to update some webhooks">
    Please use <em>Check webhooks...</em> button from the Rules tab to retry webhooks update.
  </SectionMessage>
);

const SuccessMessage = () => (
  <SectionMessage title="Webhooks updated successfully">
  </SectionMessage>
);

const SyncWebhooksAfterRuleChangeModal = () => {
  const { data, loading, error } = useDiffWebhooks();
  const [doneStatus, setDoneStatus] = useState(undefined);

  useEffect(() => {
    jira.resize({ width: '40vw' });
    changeMinHeight(350);
  }, []);

  return (
    <ModalContainer title="Checking webhooks...">
      {Boolean(error) && <ErrorMessage error={['Failed to load webhooks', error]}/>}
      {Boolean(loading && !error) && <CenteredSpinner size="large"/>}
      {data && <div>
        <WebhooksTasksTable isRunning={true} tasks={data} onDone={setDoneStatus}/>
        {doneStatus && doneStatus.hasErrors === true && <ErorrsMessage/>}
        {doneStatus && doneStatus.hasErrors === false && <SuccessMessage/>}
        <ModalButtons>
          <Button onClick={e => jira.closeCurrentModal()}>{doneStatus ? 'Close' : 'Cancel'}</Button>
        </ModalButtons>
      </div>}
    </ModalContainer>
  );
};

export default SyncWebhooksAfterRuleChangeModal;
